import { useEffect, useRef } from 'react';

export function usePrefill(value: string, setValue: (next: string) => void, incoming: string | null | undefined) {
  const applied = useRef<string | null>(null);
  useEffect(() => {
    if (!incoming || applied.current === incoming) return;
    applied.current = incoming;
    if (!value) setValue(incoming);
  }, [incoming, value, setValue]);
}
